import React, { PropsWithChildren } from 'react';

import { cn } from '@/lib/utils';

const getCountClasses = (count: number) => {
  const base =
    'grid gap-2 [&>div:not(:has(audio))]:shadow [&_img]:h-full [&_img]:w-full [&_img]:object-cover';

  switch (count) {
    case 1:
      return cn(base, 'max-w-fit grid-cols-1');
    case 2:
      return cn(base, 'max-w-81 grid-cols-2 [&>div]:h-37.5 [&>div]:w-37.5 [&>div]:overflow-hidden');
    case 3:
      return cn(
        base,
        'grid-cols-2 grid-rows-2',
        '[&>div]:flex [&>div]:h-37.5 [&>div]:max-h-75 [&>div]:w-37.5 [&>div]:items-center [&>div]:justify-center [&>div]:overflow-hidden',
        '[&>div:nth-child(3)]:col-span-2 [&>div:nth-child(3)]:max-h-37.5 [&>div:nth-child(3)]:w-77 [&>div:nth-child(3)]:max-w-77'
      );
    case 4:
      return cn(base, 'grid-cols-2 [&>div]:h-37.5 [&>div]:w-37.5');
    default:
      return cn(base, 'grid-cols-[repeat(auto-fill,minmax(150px,1fr))]');
  }
};

const Attachments = ({ children }: PropsWithChildren) => {
  const count = React.Children.count(children);
  return <div className={getCountClasses(count)}>{children}</div>;
};

export default Attachments;
